export const EVENTS = {
  SET_TIMER_STATUS_EVENT: 'set-timer-status',
  DATA_RECEIVE_EVENT: 'data-receive'
}

export const ONE_SECOND_TIME = 1000

export const DEFAULT_TIMER_COUNTDOWN = 60 * ONE_SECOND_TIME
